import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useHistory } from 'react-router-dom';
import { Alert, BlankState, Button, Card, ContentTemplate, Grid, SectionHeader } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';

const useStyles = makeStyles()((theme) =>
({
  card: {
    padding: theme.spacing(5),
  },
  backButton: {
    color: theme.color.link.linkDefault01,
  },
}));

type alertType = 'error' | 'info' | 'success' | 'warning';

export interface ClosedOpenWindowProps {
  contentBody: string;
  title?: string;
  alertMessage?: string;
  alertType?: alertType;
}

const ClosedOpenWindowCard: React.FC<ClosedOpenWindowProps> = (props: ClosedOpenWindowProps) => {
  const { contentBody, title, alertMessage, alertType } = props;
  const { classes } = useStyles();
  const history = useHistory();

  return (
    <ContentTemplate type="full" transparent continuous>
      <Grid xs={12}>
        {title && <SectionHeader title={title} />}

        {alertMessage && (
          <Alert
            message={alertMessage}
            severity={alertType}
            variant="filled"
            iconName={IconName.info}
            iconSize="M"
            style={{ marginBottom: 24 }}
          />
        )}

        <Card className={classes.card}>
          <BlankState
            label={contentBody}
            HelperComponent={
              <Button
                className={classes.backButton}
                variant="text"
                onClick={() => history.push('/')}
              >
                Back to Homepage
              </Button>
            }
          />
        </Card>
      </Grid>
    </ContentTemplate>
  );
};
export default ClosedOpenWindowCard;
